import {
  CrossIcon,
  DefaultTagIcon,
  FlagIcon,
  StationIcon,
} from '@/components/navigation/NavigationIntroScreen/components/Popup/Icons';
import { CloseButton } from '@/components/navigation/NavigationIntroScreen/components/Popup/styles';
import DeviceManager from '@/components/util/deviceManager';

export const renderIcon = (location, width, height) => {
  if (location?.iconFile) {
    let tagIconUrl;
    if (location.iconFile.startsWith('http')) {
      tagIconUrl = `${location.iconFile}`;
    } else {
      tagIconUrl = `${process.env.NEXT_PUBLIC_CDN}/tours/${location.tourId}/tags/icons/${location.iconFile}`;
    }

    return (
      <img
        width={width || '38px'}
        height={height || '38px'}
        src={tagIconUrl}
        alt={location.title as string}
      />
    );
  }

  if (location?.custom && location?.customIcon) {
    const tagIconUrl = location.iconColor
      ? `${process.env.NEXT_PUBLIC_API}/v1/public/icons/${location.customIcon}?hex=${encodeURIComponent(location.iconColor)}&circle=${
          location.whiteCircle
        }`
      : `${process.env.NEXT_PUBLIC_API}/v1/public/icons/${location.customIcon}`;

    return <img width="27px" height="27px" src={tagIconUrl} alt={location.title as string} />;
  }

  if (location?.url || location?.station) {
    return (
      <StationIcon
        style={{ width: width || '38px', height: height || '38px', borderRadius: '8px' }}
      />
    );
  }

  if (location?.sweepId) {
    return <FlagIcon style={{ width, height, borderRadius: '8px' }} />;
  }

  return <DefaultTagIcon style={{ width, height, borderRadius: '8px' }} />;
};

export const createInputProps = ({
  clearSearch,
  isSearchBarFocused,
  actionPathFinished,
  loadingFinished,
}) => {
  return {
    startAdornment: <img src="/navigation/search.svg" alt="" />,
    endAdornment:
      isSearchBarFocused && !DeviceManager.isMobile() ? (
        <div style={{ width: '50px' }}>
          <CloseButton rounded onClick={clearSearch}>
            <CrossIcon style={{}} />
          </CloseButton>
        </div>
      ) : null,
    sx: {
      background: '#fff',
      height: { xs: '57px', md: '76px' },
      borderRadius: actionPathFinished && !loadingFinished ? '8px 8px 0 0' : '8px',
      border: '1px solid #D0D5DD',
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.05)',
      backdropFilter: 'blur(20.649999618530273px)',
      color: '#101828',
      paddingRight: { xs: '10px', lg: '14px' },
      '& input': {
        fontSize: { xs: '18px', lg: '20px' },
        fontWeight: { xs: '500 !important', lg: '600 !important' },
      },
    },
  };
};

export function trimDescription(description: string, maxLength: number): string {
  if (description?.length > maxLength) {
    return `${description.substring(0, maxLength)}...`;
  }
  return description;
}
